import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { useState } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { useMetricLimitsQuery, useRealtimeInvalidation } from "./hooks/queries";
import { TablePartTypes } from "./components/TablePartTypes";

interface Props {
  title: string;
  parentPartTypeIds?: string;
}

export const MetricLimitsPage = ({ title, parentPartTypeIds }: Props) => {
  const [error, setError] = useState("");

  // Enable real-time updates via SignalR
  useRealtimeInvalidation();

  const { data: partTypes = [], isLoading } = useMetricLimitsQuery(
    parentPartTypeIds,
    (err) => setError(err.message),
  );

  return (
    <>
      <HelmetDexteel title={title} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} sx={{ m: 0 }}>
          <Paper
            elevation={1}
            sx={{
              width: "100%",
              py: 1.25,
              pb: 2.5,
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TablePartTypes
              title={title}
              partTypes={partTypes}
              isLoading={isLoading}
              parentPartTypeIds={parentPartTypeIds}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
